import Axios from 'axios';
import { YouInvest } from 'src/Api';

if (typeof window !== "undefined" && !window.YouInvest) {
    window.YouInvest = {lastKeepAlive: 0};
}

const LOCAL_STORAGE_KEY_LAST_ACTIVE_REQUEST = 'lastActiveRequest';

export default function KeepMeLoggedInInterceptor(settings) {
    const interceptor = () => {
        if (!settings.guest) {
            return Axios.interceptors.request.use(function (config) {
                if (typeof window !== "undefined") {
                    let now = new Date().getTime();
            
                    localStorage.setItem(LOCAL_STORAGE_KEY_LAST_ACTIVE_REQUEST,(new Date).getTime());
                    
                    if (window.YouInvest.lastKeepAlive + 300000 < now) {
                        window.YouInvest.lastKeepAlive = now;
                        Axios({
                            method: 'GET',
                            url: '/keepalive.php',
                            headers: YouInvest.getTradingRequestHeaders()
                        });
                    }
                }
            
                return config;
            }, function (error) {
                return Promise.reject(error);
            })
        }

        return null;
    }

    return interceptor();
}